/*
* Pipeline Theme — custom.js
*
* Collection grid hover video.
*   Desktop: play on hover.
*   Mobile:  play while a finger rests on the product; a quick tap still
*            opens the product page.
*/

(function () {

  var DEBUG     = false; // set to true to get an on-screen log while testing
  var TAP_MAX   = 250;   // ms — shorter than this counts as a tap, not a look
  var DRIFT_MAX = 40;    // px of finger drift still counted as "resting"

  var VIDEO   = '.product-grid-item__hover-video';
  var WRAPPER = '.product-grid-item__content';
  var ACTIVE  = 'is-video-active';

  var activeWrapper   = null;
  var pressWrapper    = null;
  var pressStarted    = 0;
  var startX          = 0;
  var startY          = 0;
  var resumeAttempts  = 0;
  var releaseWatchdog = null;
  var videoObserver   = null;


  /* ---------- helpers ---------- */

  function log(message) {
    if (!DEBUG) return;

    var box = document.getElementById('HoverVideoDebug');

    if (!box) {
      box = document.createElement('div');
      box.id = 'HoverVideoDebug';
      box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;max-height:35vh;' +
        'overflow:auto;z-index:99999;background:rgba(0,0,0,.85);color:#0f0;' +
        'font:11px/1.4 monospace;padding:6px;white-space:pre-wrap;pointer-events:none';
      document.body.appendChild(box);
    }

    box.textContent = (new Date()).toTimeString().slice(3, 8) + '  ' + message + '\n' + box.textContent;
  }

  function getVideoWrapper(target) {
    if (!target || !target.closest) {
      return null;
    }

    var wrapper = target.closest(WRAPPER);
        // Video-first tiles are handled by their own block at the end of the file
    if (wrapper && wrapper.querySelector('[data-video-first]')) {
      return null;
    }

    if (!wrapper || !wrapper.querySelector(VIDEO)) {
      return null;
    }

    return wrapper;
  }

  // Quick-add / quick-view buttons sit on top of the card. Touching one of
  // those is a purchase intent, not a request to preview.
  function isInteractive(target) {
    return !!(target && target.closest && target.closest('button, [data-quickview-holder]'));
  }


  /* ---------- play / stop ---------- */

  function playHoverVideo(wrapper) {
    var video = wrapper.querySelector(VIDEO);

    if (!video) {
      return;
    }

    if (activeWrapper && activeWrapper !== wrapper) {
      stopHoverVideo(activeWrapper);
    }

    activeWrapper = wrapper;

    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Only reveal once there is a real frame, so the product photo stays put
    // instead of flashing empty.
    if (video.readyState >= 2) {
      wrapper.classList.add(ACTIVE);
      log('show (already buffered)');
    } else {
      log('not buffered yet, loading… readyState=' + video.readyState);

      if (video.preload !== 'auto') {
        video.preload = 'auto';
        video.load();
      }

      video.addEventListener('loadeddata', function onLoaded() {
        video.removeEventListener('loadeddata', onLoaded);

        if (activeWrapper === wrapper) {
          wrapper.classList.add(ACTIVE);
          log('show (just loaded)');
        }
      });
    }

    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.then(function () {
        log('play ok');
      }).catch(function (error) {
        log('play BLOCKED: ' + error.name);
      });
    }
  }

  function stopHoverVideo(wrapper) {
    if (!wrapper) {
      return;
    }

    var video = wrapper.querySelector(VIDEO);

    wrapper.classList.remove(ACTIVE);

    if (activeWrapper === wrapper) {
      activeWrapper = null;
    }

    if (!video) {
      return;
    }

    video.pause();

    try {
      video.currentTime = 0;
    } catch (e) {
      // Some browsers refuse this before metadata is loaded
    }
  }


  /* ---------- preload each video as its tile scrolls into view ----------
     This is what makes the first hover/touch instant instead of a download. */

  function observeVideos() {
    if (!videoObserver) {
      return;
    }

    var videos = document.querySelectorAll(VIDEO + ':not([data-hover-preloaded])');

    for (var i = 0; i < videos.length; i++) {
      videoObserver.observe(videos[i]);
    }
  }

  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) {
          continue;
        }

        var video = entries[i].target;

        videoObserver.unobserve(video);
        video.setAttribute('data-hover-preloaded', '');
        video.preload = 'auto';
        video.load();
        log('preloading a video');
      }
    }, { rootMargin: '300px 0px' });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeVideos);
    } else {
      observeVideos();
    }

    document.addEventListener('shopify:section:load', observeVideos);

    // The collection grid is replaced wholesale when filters or sorting
    // change, so pick up the new tiles when that happens.
    if ('MutationObserver' in window) {
      var rescanTimer = null;

      new MutationObserver(function () {
        window.clearTimeout(rescanTimer);
        rescanTimer = window.setTimeout(observeVideos, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }


  /* ---------- DESKTOP ---------- */

  document.addEventListener('mouseover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    var wrapper = getVideoWrapper(event.target);

    if (!wrapper) {
      return;
    }

    if (event.relatedTarget && wrapper.contains(event.relatedTarget)) {
      return;
    }

    playHoverVideo(wrapper);
  });

  document.addEventListener('mouseout', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    var wrapper = getVideoWrapper(event.target);

    if (!wrapper) {
      return;
    }

    if (event.relatedTarget && wrapper.contains(event.relatedTarget)) {
      return;
    }

    stopHoverVideo(wrapper);
  });


  /* ---------- MOBILE: finger down = play, finger up = stop ----------
     Every listener is passive and never calls preventDefault(), so
     scrolling can never be blocked. */

  function clearPress() {
    if (releaseWatchdog) {
      window.clearTimeout(releaseWatchdog);
      releaseWatchdog = null;
    }
  }

  // After a hold, swallow the click the browser fires on release so the
  // customer stays on the collection page instead of opening the product.
  function suppressNextClick() {
    var swallow = function (event) {
      event.preventDefault();
      event.stopPropagation();
      document.removeEventListener('click', swallow, true);
    };

    document.addEventListener('click', swallow, true);

    window.setTimeout(function () {
      document.removeEventListener('click', swallow, true);
    }, 700);
  }

  function releasePress(reason) {
    clearPress();

    if (!pressWrapper) {
      return;
    }

    var wrapper = pressWrapper;
    var heldFor = Date.now() - pressStarted;

    pressWrapper = null;   // cleared first, so the resume watchdog stays quiet
    resumeAttempts = 0;

    stopHoverVideo(wrapper);

    if (reason === 'release' && heldFor >= TAP_MAX) {
      suppressNextClick();
    }

    log('stopped (' + reason + ') after ' + heldFor + 'ms');
  }

  document.addEventListener('touchstart', function (event) {
    if (event.touches.length !== 1) {
      return;            // a second finger must not kill the current preview
    }

    if (isInteractive(event.target)) {
      releasePress('touched a button');
      return;
    }

    var wrapper = getVideoWrapper(event.target);

    if (!wrapper) {
      releasePress('touched elsewhere');
      return;
    }

    if (pressWrapper === wrapper) {
      return;            // already previewing this one — leave it alone
    }

    releasePress('switched product');

    pressWrapper = wrapper;
    pressStarted = Date.now();
    resumeAttempts = 0;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;

    log('touchstart');
    playHoverVideo(wrapper);
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!pressWrapper || !event.touches.length) {
      return;
    }

    var deltaX = Math.abs(event.touches[0].clientX - startX);
    var deltaY = Math.abs(event.touches[0].clientY - startY);

    if (deltaX <= DRIFT_MAX && deltaY <= DRIFT_MAX) {
      return;            // finger is still resting — keep playing
    }

    releasePress('finger moved ' + Math.round(Math.max(deltaX, deltaY)) + 'px');
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    if (event.touches.length > 0) {
      return;            // another finger is still down
    }

    releasePress('release');
  }, { passive: true });

  window.addEventListener('pointerup', function () {
    releasePress('release');
  });

  /* iOS and Android cancel the touch sequence for their own gestures
     (link preview, image drag, scroll hand-off). That does NOT mean the
     finger left the screen, so keep playing and wait for a real release. */
  document.addEventListener('touchcancel', function () {
    if (!pressWrapper) {
      return;
    }

    log('touchcancel — IGNORED, video keeps playing');
    clearPress();

    releaseWatchdog = window.setTimeout(function () {
      releasePress('safety timeout');
    }, 15000);
  }, { passive: true });

  /* If the phone pauses the video by itself (buffer stall, or iOS reclaiming
     a video decoder) while the finger is still down, start it again. */
  document.addEventListener('pause', function (event) {
    if (!pressWrapper || !pressWrapper.contains(event.target)) {
      return;
    }

    if (resumeAttempts >= 5) {
      log('gave up resuming');
      return;
    }

    resumeAttempts++;
    log('video paused itself — resuming (' + resumeAttempts + ')');

    var resume = event.target.play();

    if (resume !== undefined) {
      resume.catch(function () {});
    }
  }, true);

  /* Touch devices only: stop the phone turning a resting finger into one of
     its own gestures — the link context menu, or lifting a product image
     into a drag preview. Desktop right-click and image-drag are untouched. */
  function isTouchDevice() {
    return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('contextmenu', function (event) {
    if (isTouchDevice() && getVideoWrapper(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (event) {
    if (isTouchDevice() && event.target && event.target.closest &&
        event.target.closest('.product-grid-item__container')) {
      log('drag lift blocked');
      event.preventDefault();
    }
  });

})();

/* ==========================================================
   VIDEO-FIRST PRODUCTS  (product tag: video-first)
   The video plays on its own while the tile is on screen.
   Desktop hover / a resting finger on mobile shows the photo;
   leaving / lifting goes back to the video.
   ========================================================== */
(function () {

  var WRAPPER   = '.product-grid-item__content';
  var VIDEO     = 'video[data-video-first]';
  var ACTIVE    = 'is-video-active';
  var TAP_MAX   = 250;   // ms — shorter than this is a tap that opens the product
  var DRIFT_MAX = 40;    // px of finger drift still counted as "resting"

  if (!('IntersectionObserver' in window)) {
    return;              // very old browser: the tile simply stays a photo
  }

  var pressed      = null;
  var pressStarted = 0;
  var startX       = 0;
  var startY       = 0;


  /* ---------- helpers ---------- */

  function wrapperOf(el) {
    return el && el.closest ? el.closest(WRAPPER) : null;
  }

  function videoIn(wrapper) {
    return wrapper ? wrapper.querySelector(VIDEO) : null;
  }

  function isFinePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }


  /* ---------- one place decides what a tile shows ----------
       hovered or pressed        -> photo
       off screen                -> paused
       on screen, left alone     -> video */

  function update(video) {
    var wrapper = wrapperOf(video);

    if (video.vfPhoto) {
      if (wrapper) {
        wrapper.classList.remove(ACTIVE);
      }
      video.pause();
      return;
    }

    if (!video.vfVisible) {
      video.pause();
      return;
    }

    video.muted = true;
    video.preload = 'auto';

    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function () {
        // Interrupted while still loading: try again once it can play.
        // If the phone refuses autoplay, the photo simply stays.
        video.addEventListener('canplay', function () {
          update(video);
        }, { once: true });
      });
    }
  }

  // Reveal the video only once frames are really moving, so the photo
  // never flashes empty.
  document.addEventListener('playing', function (event) {
    var video = event.target;

    if (video.matches && video.matches(VIDEO) && !video.vfPhoto) {
      var wrapper = wrapperOf(video);

      if (wrapper) {
        wrapper.classList.add(ACTIVE);
      }
    }
  }, true);


  /* ---------- play while on screen, pause when scrolled away ---------- */

  var observer = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      entries[i].target.vfVisible = entries[i].isIntersecting;
      update(entries[i].target);
    }
  }, { threshold: 0.25 });

  function scan() {
    var videos = document.querySelectorAll(VIDEO + ':not([data-vf-watched])');

    for (var i = 0; i < videos.length; i++) {
      videos[i].setAttribute('data-vf-watched', '');
      observer.observe(videos[i]);
    }
  }

  function start() {
    scan();

    // The grid is replaced when filters or sorting change.
    if ('MutationObserver' in window) {
      var rescanTimer = null;

      new MutationObserver(function () {
        window.clearTimeout(rescanTimer);
        rescanTimer = window.setTimeout(scan, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scan);


  /* ---------- DESKTOP: hover shows the photo ---------- */

  document.addEventListener('mouseover', function (event) {
    if (!isFinePointer()) {
      return;
    }

    var wrapper = wrapperOf(event.target);
    var video   = videoIn(wrapper);

    if (!video || (event.relatedTarget && wrapper.contains(event.relatedTarget))) {
      return;
    }

    video.vfPhoto = true;
    update(video);
  });

  document.addEventListener('mouseout', function (event) {
    if (!isFinePointer()) {
      return;
    }

    var wrapper = wrapperOf(event.target);
    var video   = videoIn(wrapper);

    if (!video || (event.relatedTarget && wrapper.contains(event.relatedTarget))) {
      return;
    }

    video.vfPhoto = false;
    update(video);
  });


  /* ---------- MOBILE: finger down = photo, finger up = video ----------
     Every listener is passive and never calls preventDefault() on touch,
     so scrolling can never be blocked. */

  function swallowNextClick() {
    var swallow = function (event) {
      event.preventDefault();
      event.stopPropagation();
      document.removeEventListener('click', swallow, true);
    };

    document.addEventListener('click', swallow, true);

    window.setTimeout(function () {
      document.removeEventListener('click', swallow, true);
    }, 700);
  }

  function release(lifted) {
    if (!pressed) {
      return;
    }

    var video   = pressed;
    var heldFor = Date.now() - pressStarted;

    pressed = null;
    video.vfPhoto = false;
    update(video);

    // A hold keeps the customer on the collection page; a quick tap opens it.
    if (lifted && heldFor >= TAP_MAX) {
      swallowNextClick();
    }
  }

  document.addEventListener('touchstart', function (event) {
    if (event.touches.length !== 1) {
      return;
    }

    var video = videoIn(wrapperOf(event.target));

    if (video && video === pressed) {
      return;
    }

    release(false);

    if (!video || event.target.closest('button, [data-quickview-holder]')) {
      return;
    }

    pressed      = video;
    pressStarted = Date.now();
    startX       = event.touches[0].clientX;
    startY       = event.touches[0].clientY;

    video.vfPhoto = true;
    update(video);
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    if (!pressed || !event.touches.length) {
      return;
    }

    var deltaX = Math.abs(event.touches[0].clientX - startX);
    var deltaY = Math.abs(event.touches[0].clientY - startY);

    if (deltaX > DRIFT_MAX || deltaY > DRIFT_MAX) {
      release(false);   // it's a scroll, not a look
    }
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    if (event.touches.length === 0) {
      release(true);
    }
  }, { passive: true });

  window.addEventListener('pointerup', function () {
    release(true);
  });

  // touchcancel is deliberately NOT treated as a release (iOS fires it for its own gestures).

  document.addEventListener('contextmenu', function (event) {
    if (!isFinePointer() && videoIn(wrapperOf(event.target))) {
      event.preventDefault();
    }
  });

})();